import { useCallback, useState } from "react";

import {
    type IOuterSearchBarProps,
    SearchBar,
} from "commonComponents/utilities/MainNavigation/searchLegacy/SearchBar";

export const ResizableSearchBar: React.FunctionComponent<IOuterSearchBarProps> = (props) => {
    const [isSearchCollapsed, setIsSearchCollapsed] = useState(false);

    const handleSearchToggled = useCallback(() => {
        setIsSearchCollapsed((prev) => !prev);
    }, []);

    return (
        <div className="ResizableSearchBar">
            <SearchBar
                {...props}
                isCollapsed={props.isCollapsed ?? isSearchCollapsed}
                onSearchToggle={handleSearchToggled}
            />
        </div>
    );
};
